import { Chip, Stack } from '@mui/material';
import type { PreviewFilter, PreviewSummary } from './types';

interface PreviewSummaryChipsProps {
  filter: PreviewFilter;
  summary: PreviewSummary;
  onFilterChange: (next: PreviewFilter) => void;
}

interface ChipDef {
  filter: PreviewFilter;
  label: string;
  color: 'default' | 'success' | 'warning' | 'error';
  hideWhenZero: boolean;
  count: number;
}

export const PreviewSummaryChips = ({
  filter,
  summary,
  onFilterChange,
}: PreviewSummaryChipsProps) => {
  const chips: ChipDef[] = [
    {
      filter: 'all',
      label: `${summary.total} filas`,
      color: 'default',
      hideWhenZero: false,
      count: summary.total,
    },
    {
      filter: 'importable',
      label: `${summary.importable} importables`,
      color: 'success',
      hideWhenZero: false,
      count: summary.importable,
    },
    {
      filter: 'with_warnings',
      label: `${summary.withWarnings} con avisos`,
      color: 'warning',
      hideWhenZero: false,
      count: summary.withWarnings,
    },
    {
      filter: 'blocked',
      label: `${summary.blocked} con errores`,
      color: 'error',
      hideWhenZero: true,
      count: summary.blocked,
    },
    {
      filter: 'skipped',
      label: `${summary.skipped} omitidas`,
      color: 'default',
      hideWhenZero: true,
      count: summary.skipped,
    },
    {
      filter: 'duplicates',
      label: `${summary.duplicates} duplicados`,
      color: 'warning',
      hideWhenZero: true,
      count: summary.duplicates,
    },
  ];

  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {chips
        .filter((chip) => !(chip.hideWhenZero && chip.count === 0))
        .map((chip) => {
          const isActive = filter === chip.filter;
          return (
            <Chip
              key={chip.filter}
              label={chip.label}
              color={chip.color === 'default' ? undefined : chip.color}
              variant={isActive ? 'filled' : 'outlined'}
              onClick={() => onFilterChange(chip.filter)}
              sx={{
                cursor: 'pointer',
                fontWeight: isActive ? 600 : 400,
              }}
            />
          );
        })}
    </Stack>
  );
};
